import { render, staticRenderFns } from "./ObtenerApp.vue?vue&type=template&id=53d0fb70&scoped=true&"
import script from "./ObtenerApp.vue?vue&type=script&lang=js&"
export * from "./ObtenerApp.vue?vue&type=script&lang=js&"
import style0 from "./ObtenerApp.vue?vue&type=style&index=0&id=53d0fb70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d0fb70",
  null
  
)

export default component.exports